/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Ladataan...',
	'dlg_close': 'Sulje',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Peruuta',
	'dlg_back': 'Takaisin',
	'dlg_done': 'Valmis',
	'dlg_save': 'Tallenna',

	// Slider
	'sliderRegionLabel': 'Liukusäädinohjausobjekti, siirrä liukusäätimen kahvoja oikealla ja vasemmalla nuolinäppäimellä',
	'sliderHandleLabel': 'Liukusäätimen kahva',
	'a11ySliderHandleLabel': 'Liukusäätimen kahva %{sliderValue}',
	'sliderInputLabel': 'arvo',

	// Side bar
	'sidebarAdd': 'Lisää',
	'clearTextFilterValue': 'Tyhjennä',
	'missingDataSetData': 'Tämän tietojoukon tiedot eivät ole käytettävissä. Päivitä tietojoukko, tai pyydä pääkäyttäjältä lähteen käyttöoikeus.',

	// Toolbar
	'toolbarRegionLabel': 'Työkalurivi',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Fonttiperhe',
	'fontFamilyStyle': 'Fontin tyyli',
	'regularFontStyle': 'Normaali',
	'fontSizeSelect': 'Fonttikoko',
	'fontColorSelect': 'Väri',
	'fontStyle': 'Tyyli',
	'colorPickerTitle': 'Värin valinta',
	'bold': 'Lihavoitu',
	'italic': 'Kursivoitu',
	'underline': 'Alleviivaus',
	'fontAlignment': 'Tasaus',
	'justifyLeft': 'Tasaa vasemmalle',
	'justifyCenter': 'Tasaa keskelle',
	'justifyRight': 'Tasaa oikealle',
	'insertOrderedList': 'Järjestetty luettelo',
	'insertUnorderedList': 'Järjestämätön luettelo',
	'fontColorPicker': 'Värinvalitsin',
	'textWrap': 'Rivitä teksti',
	'restore': 'Palauta oletukset',
	'textAutoFontSize': 'Automaattinen',
	'textDefaultFontSize': 'Oletusarvo',
	'textItemTitle': 'Otsikko',
	'textLabelShadow': 'Nimiön varjo',
	'textContrastLabelColor':'Kontrastiväri',
	'toggleOn': 'Käytössä',
	'toggleOff': 'Poissa käytöstä',
	'contrastLabelColorInfo': 'Mukauta nimiön väri automaattisesti helppokäyttötoimintoja varten. Tämä ohittaa fontin värin.',
	'labelShadowInfo':'Lisää tekstiin varjo helppokäyttötoimintoja varten.',
	'applyToAll':'Käytä tyyliä kaikille akseleille',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Tulosten määrä (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Prosentti (%{lower} % - %{higher} %)',
	'topbottomSelectOption': 'Ylin tai alin -asetus',
	'topbottomOptionLabel': 'Näytä',
	'searchByLabel': 'Hakuehto',
	'searchNoMatches': 'Vastineita ei löytynyt',
	'topbottomRankColumnLabel': 'Lisää taulukkoon järjestyssarake',
	'topbottomNone': 'Ei mitään',
	'topCount': 'Ensimmäisten lukumäärä',
	'topPercent': 'Ylin %',
	'bottomCount': 'Viimeisten lukumäärä',
	'bottomPercent': 'Alin %',
	'searchColumn': 'Etsi sarake',
	'searchColumnAriaLabel': 'Etsi sarake. Kirjoita haettavan sarakkeen nimi ja etsi sarake luettelosta alanuolinäppäimellä.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Luokitus (%{columnLabel})',
	'topbottomClearLabel': 'Palauta',

	// Format
	'formatAuto': 'Automaattinen',
	'formatConvertPercent': 'Muunna desimaaliluvusta prosenttiluvuksi',
	'formatAbbreviate': 'Lyhennä',
	'formatUseGrouping': 'Käytä tuhaterotinta',
	'dateStyle': 'Päivämäärän tyyli',
	'dateTimeStyle': 'Päivämäärän/ajan tyyli',
	'formatMissingValueCharactersInfo': 'Puuttuvan arvon merkki määrittää merkit, jotka näytetään, kun arvo puuttuu.',
	'currencySymbolLabel': 'Valuuttasymboli',
	'customSymbolPlaceholder': 'Lisää symboli',
	'customSymbolLabelInfo': 'Määrittää merkin tai merkit, jota/joita käytetään mukautettuna symbolina. Tämä symboli näkyy luvun ja muiden merkkien edellä.',
	'numberLabel': 'Luvun nimiö',
	'numberPositionLabel': 'Nimiön sijainti',
	'negativeSignPosition': 'Negatiivisen merkin paikka',
	'negativeSign': 'Negatiivisen merkin symboli',
	'numberLabelInfo': 'Määrittää muotoillun luvun nimiön, joka lisätään nimiön sijainnin mukaan etu- tai jälkiliitteeksi.',
	'nullValueDefault': '<oletus>',
	'nullValueContent': '(ei arvoa)',
	'default': 'Oletus',
	'beginning': 'Alkaa',
	'end': 'Päättyy',
	'formatLabel': 'Valitse muoto',

	// More data indicator
	'moreDataIndicator': 'Tiedot on leikattu %{threshold} kohteen jälkeen. Näytä vähemmän tietoja suodattamalla.',

	// Expanded View / Focus mode
	'evCollapse': 'Tiivistä',
	'duplicate': 'Kaksoiskappale',
	'copyOf': 'Kopio kohteesta %{name}',
	'unableToDuplicateBoard': 'Kohteen %{name} kopiointi ei onnistu.',

	// Widget list
	'errorLoadingWidgetList': 'Objektien lataus ei onnistu.',

	// Custom widgets
	'customWidget': 'Mukautettu pienoisohjelma',

	// Auto group
	'group': 'Ryhmä',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hiusviiva',
	'textFontFamilySubClassThin': 'Ohut',
	'textFontFamilySubClassThinItalic': 'Ohut kursivoitu',
	'textFontFamilySubClassExtraLight': 'Hyvin ohut',
	'textFontFamilySubClassExtraLightItalic': 'Hyvin ohut kursivoitu',
	'textFontFamilySubClassLight': 'Ohuehko',
	'textFontFamilySubClassLightItalic': 'Ohuehko kursivoitu',
	'textFontFamilySubClassRegular': 'Normaali',
	'textFontFamilySubClassRegularItalic': 'Tavallinen kursivoitu',
	'textFontFamilySubClassItalic': 'Kursiivi',
	'textFontFamilySubClassMedium': 'Keskikokoinen',
	'textFontFamilySubClassMediumItalic': 'Keskikokoinen kursivoitu',
	'textFontFamilySubClassHeavy': 'Paksu',
	'textFontFamilySubClassHeavyItalic': 'Paksu kursivoitu',
	'textFontFamilySubClassDemiBold': 'Puolilihavoitu',
	'textFontFamilySubClassDemiBoldItalic': 'Puolilihavoitu kursivoitu',
	'textFontFamilySubClassBold': 'Lihavointi',
	'textFontFamilySubClassBoldItalic': 'Lihavoitu kursivoitu',
	'textFontFamilySubClassExtraBold': 'Hyvin paksu',
	'textFontFamilySubClassExtraBoldItalic': 'Hyvin paksu kursivoitu',
	'textFontFamilySubClassBlack': 'Musta',
	'textFontFamilySubClassBlackItalic': 'Musta kursivoitu',
	'textFontFamilySubClassStencil': 'Stencil-fontti',
	// END: Remove FontFamilySubClass
});
